var root = require("./_root");

/** Built-in value references. */
var _Symbol = root.Symbol;
module.exports = _Symbol;